import React from 'react'

import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import SkeletonPill from '@hi/react-material/SkeletonPill'

const useStyles = makeStyles(() => ({
  container: {
    marginLeft: '25px',
  },
  text: {
    marginTop: '8px',
  },
  skeletonSize: {
    width: '80%',
  },
}))

function TableSkeleton({ menuOptions }) {
  const classes = useStyles()

  return (
    <Grid container>
      <Grid item xs={9}>
        <Grid container direction="column" className={classes.container}>
          <Grid item xs={4}>
            <SkeletonPill height={18} />
          </Grid>
          <Grid item xs={7} className={classes.text}>
            <SkeletonPill height={44} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={3}>
        <Grid container justifyContent="space-evenly" className={classes.container}>
          <Grid item xs={9}>
            <Grid container direction="column">
              <Grid item xs={4}>
                <SkeletonPill height={12} />
              </Grid>
              <Grid item xs={6} style={{ marginTop: '2px' }}>
                <SkeletonPill height={12} />
              </Grid>
            </Grid>
          </Grid>
          {menuOptions && (
            <Grid item xs={3}>
              <div style={{ width: '2.5rem' }}>
                <SkeletonPill borderRadius="50%" height={36} />
              </div>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TableSkeleton
